/**
 * 分または秒から時間を取得する
 * @param {*} value 
 * @param {*} isMinutes 
 */
 exports.toHours = function (value, isMinutes = true) {
    if (isMinutes) {
        return Math.floor(value / 60) ;
    } else {
        return Math.floor(Math.floor(value / 60) / 60);
    }
};
/**
 * 時間または秒から分を取得する
 * @param {*} value 
 * @param {*} isHours 
 */
 exports.toMinutes = function (value, isHours = true) {
    if (isHours) {
        return value * 60;
    } else {
        return Math.floor(value / 60);
    }
};
/**
 * 時間または分から秒を取得する
 * @param {*} value 
 * @param {*} isHours 
 */
 exports.toSeconds = function (value, isMinutes = true) {
    if (isMinutes) {
        return value * 60;
    } else {
        return value * 60 * 60;
    }
};

/**
 * フォームの内容をJSONに
 * @param formSelectorId
 * @param jsonStringify
 */
exports.createJsonParams = function (formSelectorId, jsonStringify = true) {
     let params = {};

     $.each($(formSelectorId).serializeArray(), function(i, v) {
         let key = v.name;
         if (key.indexOf('[]') !== -1) {
             key = key.replace('[]', '');
             // 配列形式 key[]
             if (key in params) {
                 params[key].push(v.value);
             } else {
                 params[key] = [v.value];
             }
         } else if (/\[\d+\]\[\d+\]$/.test(key)) {
             // key[apple][remon]の形
             let keys = key.match(/[^[\]]+/g);
             keys.reduce((acc, k, i) => {
                 if (i === keys.length - 1) {
                     acc[k] = v.value;
                 } else {
                     acc[k] = acc[k] || {};
                 }
                 return acc[k];
             }, params);
         } else {
             params[key] = v.value;
         }
     });

    return jsonStringify ? JSON.stringify(params) : params;
};
